export default {"src":"/_next/static/media/lot-of-trees.de4edcd0.svg","height":23,"width":30,"blurWidth":0,"blurHeight":0};